export default __webpack_public_path__ + "static/media/1861.7ebf366e.png";